import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { RichTextControlComponent } from '../../../controls/standard/rich-text-control/rich-text-control.component';

@Component({
	selector: 'app-html-description-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, RichTextControlComponent],
	templateUrl: './html-description-field.component.html',
	styleUrls: ['./html-description-field.component.scss'],
})
export class HtmlDescriptionFieldComponent extends BaseFieldComponent {
	@ViewChild(RichTextControlComponent, { static: false })
	public richTextControl!: RichTextControlComponent;
	@Output('onFocus') public onFocusEmitter: EventEmitter<any> = new EventEmitter<any>();

	/**
	 * All validators required for this field.
	 * @date 7/15/2022 - 12:27:06 PM
	 *
	 * @public
	 * @static
	 * @override
	 * @type {ValidatorFn[]}
	 */
	public static override validators: ValidatorFn[] = [
		Validators.required,
		Validators.minLength(1),
		Validators.maxLength(20000),
	];
}
